import { useTranslation } from "react-i18next";
import { PageHeader, SectionHeader, PrimaryLink } from "../components/ui-blocks";
import { CLIENT_LOGOS, IMAGES } from "../lib/content";

export default function Partnerships() {
  const { t } = useTranslation();
  // Duplicate logos for seamless marquee
  const track = [...CLIENT_LOGOS, ...CLIENT_LOGOS];

  return (
    <>
      <PageHeader
        testId="partnerships-header"
        overline={t("partnerships.headerOverline")}
        title={t("partnerships.headerTitle")}
        lead={t("partnerships.headerLead")}
        backgroundImage={IMAGES.handshake}
      />

      <section className="section-pad" data-testid="partnerships-intro">
        <div className="container-mtbl grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <SectionHeader
              overline={t("partnerships.introOverline")}
              title={t("partnerships.introTitle")}
            />
          </div>
          <div className="lg:col-span-7 space-y-6 text-slate-600 text-base md:text-lg leading-relaxed">
            <p>{t("partnerships.introP1")}</p>
            <p>{t("partnerships.introP2")}</p>
          </div>
        </div>
      </section>

      <section
        data-testid="partnerships-logos"
        className="bg-paper border-y border-slate-200 py-16 md:py-20 overflow-hidden"
      >
        <div className="container-mtbl mb-10">
          <p className="overline">{t("partnerships.logosOverline")}</p>
          <h2 className="mt-3 text-[#0B1A3D] text-2xl md:text-3xl font-semibold tracking-tight">
            {t("partnerships.logosTitle")}
          </h2>
        </div>
        <div className="relative">
          <div className="logo-track">
            {track.map((l, idx) => {
              const isDark = l.name === "Black Knight Associates";
              const zoomedIn = l.name === "Black Knight Associates";
              return (
                <div
                  key={`${l.name}-${idx}`}
                  data-testid={`partner-logo-${idx}`}
                  className={`shrink-0 w-60 md:w-72 h-32 md:h-36 mx-4 md:mx-6 rounded-2xl shadow-[0_1px_2px_rgba(15,23,42,0.04)] flex items-center justify-center overflow-hidden border ${
                    zoomedIn ? "p-2" : "p-6"
                  } ${
                    isDark
                      ? "bg-[#0B1A3D] border-[#0B1A3D]"
                      : "bg-white border-slate-200"
                  }`}
                  title={l.name}
                >
                  <img
                    src={l.url}
                    alt={l.name}
                    className={`object-contain opacity-90 hover:opacity-100 transition-opacity ${
                      zoomedIn
                        ? "w-full h-full scale-[1.35]"
                        : "max-h-full max-w-full"
                    }`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section data-testid="partnerships-cta" className="section-pad bg-white">
        <div className="container-mtbl flex flex-col md:flex-row items-start md:items-center justify-between gap-8 rounded-2xl border border-slate-200 bg-paper p-10 md:p-14">
          <h3 className="text-[#0B1A3D] text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight max-w-2xl">
            {t("partnerships.ctaTitle")}
          </h3>
          <PrimaryLink to="/contact?type=strategic" testId="partnerships-cta-contact">
            {t("common.strategicPartnerships")}
          </PrimaryLink>
        </div>
      </section>
    </>
  );
}
